import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';
import { InfosPopupContent } from '../InfosPopup/InfosPopupContent';
import { jsx as _jsx } from "react/jsx-runtime";
export var InfosPopupModal = function InfosPopupModal(_ref) {
  var open = _ref.open,
    builders = _ref.builders,
    sellers = _ref.sellers,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    placeType = _ref.placeType,
    onPhoneOpen = _ref.onPhoneOpen,
    onClose = _ref.onClose,
    openContactsSellerPhoneStyles = _ref.openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles = _ref.openContactsBuilderPhoneStyles,
    phoneButtonTestId = _ref.phoneButtonTestId;
  return /*#__PURE__*/_jsx(ModalWindow, {
    size: "XS",
    open: open,
    content: /*#__PURE__*/_jsx(InfosPopupContent, {
      httpApi: httpApi,
      logger: logger,
      pageType: pageType,
      platformType: platformType,
      placeType: placeType,
      builders: builders,
      sellers: sellers,
      onPhoneOpen: onPhoneOpen,
      openContactsSellerPhoneStyles: openContactsSellerPhoneStyles,
      openContactsBuilderPhoneStyles: openContactsBuilderPhoneStyles,
      phoneButtonTestId: phoneButtonTestId
    }),
    onClose: onClose,
    width: "400px"
  });
};